var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9889 4.31614C17.9889 3.86214 17.6208 3.49406 17.1668 3.49406H6.83329C6.37931 3.49406 6.01121 3.86215 6.01121 4.31614V20.555C6.01121 21.009 6.3793 21.377 6.83329 21.377H17.1668C17.6208 21.377 17.9889 21.009 17.9889 20.555V4.31614ZM12.7386 17.6866C13.0998 17.6868 13.3929 17.9797 13.3929 18.3409C13.3927 18.702 13.0997 18.995 12.7386 18.9951H11.2623C10.901 18.9951 10.6082 18.7021 10.608 18.3409C10.608 17.9795 10.901 17.6866 11.2623 17.6866H12.7386ZM19.2974 20.555C19.2974 21.7316 18.3435 22.6855 17.1668 22.6855H6.83329C5.65665 22.6855 4.7027 21.7316 4.7027 20.555V4.31614C4.7027 3.13948 5.65664 2.18555 6.83329 2.18555H17.1668C18.3435 2.18555 19.2974 3.13949 19.2974 4.31614V20.555Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.0fe6c0862c7d60e529fbc637a17f9f54.svg";
export { ForwardRef as ReactComponent };